(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('CompanySession', CompanySession);

    CompanySession.$inject = ['$http', '$localStorage', 'CompanySubscriptionStatusCustom'];

    function CompanySession($http, $localStorage, CompanySubscriptionStatusCustom) {
        var service = {
            hasValidSubscription: hasValidSubscription,
            resetCompanySession: resetCompanySession,
            checkValidSubscription: checkValidSubscription
        };

        return service;

        function hasValidSubscription() {

            var lastCheck = getTimeStamp();
            if (!$localStorage.lastSubscriptionCheck)
                $localStorage.lastSubscriptionCheck = lastCheck;

            if ($localStorage.companyHasSubscription != undefined && !lastCheckExpired())
                return $localStorage.companyHasSubscription;
            else {
                $localStorage.lastSubscriptionCheck = getTimeStamp();
                CompanySubscriptionStatusCustom.isCurrentCompanyHasActiveSubscription().query(function (result) {

                    var hasSubscription = true;
                    if (result.status == 'DONE')
                        hasSubscription = true;
                    else
                        hasSubscription = false;

                    $localStorage.companyHasSubscription = hasSubscription;
                    return hasSubscription;
                }, function () {
                    $localStorage.companyHasSubscription = false;
                    return false;
                });
            }
        }

        function checkValidSubscription(then) {

            var lastCheck = getTimeStamp();
            if (!$localStorage.lastSubscriptionCheck)
                $localStorage.lastSubscriptionCheck = lastCheck;

            if ($localStorage.companyHasSubscription != undefined && !lastCheckExpired()) {
                if (then)
                    then($localStorage.companyHasSubscription);

                return $localStorage.companyHasSubscription;
            } else {
                $localStorage.lastSubscriptionCheck = getTimeStamp();
                CompanySubscriptionStatusCustom.isCurrentCompanyHasActiveSubscription().query(function (result) {

                    var hasSubscription = true;
                    if (result.status == 'DONE')
                        hasSubscription = true;
                    else
                        hasSubscription = false;

                    $localStorage.companyHasSubscription = hasSubscription;
                    if (then)
                        then($localStorage.companyHasSubscription);
                    return hasSubscription;
                }, function () {
                    $localStorage.companyHasSubscription = false;
                    if (then)
                        then($localStorage.companyHasSubscription);
                    return false;
                });
            }
        }

        function resetCompanySession() {
            delete $localStorage.companyHasSubscription;
        }


        function getTimeStamp() {
            var now = new Date();
            var stampMinute = Math.ceil(now.getTime() / 60000);
            return stampMinute;
        }

        function lastCheckExpired() {
            if (!$localStorage.lastSubscriptionCheck)
                return false;

            if (getTimeStamp() - $localStorage.lastSubscriptionCheck > 30)
                return true;

            return false;
        }

    }
})();
